/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../controls.module.ts" />

module Meevo.Components.Controls {
    'use strict';

    interface IHtmlEditorScope extends ng.IScope {
        config: any;
        disabled: boolean;
        trustHtml: Function;
        ngModel: string;
    }

    export class HtmlEditor implements angular.IDirective {
        restrict = 'E';
        scope = {
            ngModel: '=ngModel',
            disabled: '=?ngDisabled',
            config: '=?config',
            charLimit: '=?charLimit',
            changed: "=?changed",
        };
        require = "ngModel";
        templateUrl = 'app/components/controls/htmlEditor/htmlEditor.template.html';

        public basicTemplateConfig =
        {
            toolbar: [
                { name: 'basicStyling', items: ['bold', 'italic', 'underline'] },
                { name: "paragraph", items: ["orderedList", "unorderedList", "-"] }
            ],
        };

        pasteHandlerAdded: boolean = false;
        compile(element, attributes)
        {
            return {
                pre: function (scope, element, attributes, controller, transcludeFn) {
                    if (scope.config == null) {
                        scope.config = this.basicTemplateConfig;
                    }

                    let sce = this.$sce;

                    scope.trustHtml = function (string) {
                        return sce.trustAsHtml(string);
                    }
                },
                post: function (scope, element, attributes, controller, transcludeFn) {
                    if (scope.charLimit) {
                        if (scope.ngModel) {
                            scope.countLeft = scope.charLimit - scope.ngModel.length;
                        }
                        else {
                            scope.countLeft = scope.charLimit;
                        }
                    }

                    if (scope.charLimit) {
                        scope.$watch(() => scope.ngModel, (currentValue, prevValue) => {
                            if (currentValue) {
                                scope.countLeft = scope.charLimit - currentValue.length;
                            }
                            else {
                                scope.countLeft = scope.charLimit;
                            }
                        });
                    }

                    scope.onChange = () => {
                        if (scope.changed) {
                            scope.$eval(scope.changed);
                        }
                    }

                    if (!this.pasteHandlerAdded) {
                        let iframeObj = element.find("wysiwyg-edit iframe");
                        if (iframeObj.length > 0) {
                            iframeObj[0].contentDocument.body.onpaste = this.pasteHandler;
                            this.pasteHandlerAdded = true;
                        }
                    }
                }
            }
        }

        pasteHandler = (cbEvent) => {
            if (cbEvent.type == "paste") {
                const target = cbEvent.target;
                const transfer: DataTransfer = cbEvent['clipboardData'] || cbEvent['dataTransfer'];
                if (target) {
                    cbEvent.preventDefault();
                    var stringData = transfer.getData("text/plain");
                    //transfer.clearData("text/html");
                    //transfer.clearData();
                    //transfer.setData("text/plain", stringData);
                    stringData = stringData.replace(/\n/g, "<br/>");
                    let doc = target.ownerDocument;
                    let sel: Selection = doc ? doc.getSelection() : target.getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        let o = sel.getRangeAt(0);
                        o.deleteContents();
                        var r = doc.createElement("div");
                        r.innerHTML = stringData;
                        for (var a, l, s = doc.createDocumentFragment(); a = r.firstChild;)
                            l = s.appendChild(a);
                        s.firstChild;
                        o.insertNode(s),
                            l && (o = o.cloneRange(),
                                o.setStartAfter(l),
                                o.collapse(!0),
                                sel.removeAllRanges(),
                                sel.addRange(o))
                    }
                }
            }
        };

        private eventHandlers = [];
        link(scope: IHtmlEditorScope, element: JQuery, attrs, ctrl: ng.INgModelController) {
            this.pasteHandlerAdded = false;
        }

        constructor(public $sce: ng.ISCEService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($sce) => {
                return new HtmlEditor($sce);
            };
            directive.$inject = ['$sce'];
            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('htmlEditor', HtmlEditor.factory());
}